// Library imports
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { Input as AntdInput, Row, Col, Select, Tag } from "antd";
import { useSelector } from "react-redux";
import store, { RootState } from "store/index";
import FadeIn from "react-fade-in";

// Local Imports
import FooterActionButton from "../../CampaignAssets/Components/FooterActionButton";
import Input from "../../../Common/Components/Input";
import { createNewAudienceList } from "./actions";
import { ReactComponent as CrossIcon } from "assets/img/icons/cross.svg";
import Message from "modules/Common/Components/Message";
import { AUDIENCE_LISTS_ADD } from "constants/types/audienceTypes";
import CustomSelectAsset from "modules/Design/Assets/CustomSelectAsset";
import NewListModule from "../Components/NewListModule";
import { searchListContacts } from "../actions";
import { debounce, getQueryListId } from "utils";
import Checkbox from "../../../Common/Components/Checkbox";
import KeywordSourceV2 from "modules/Campaigns/CampaignAssets/Components/KeywordSourceV2";
import { dynamicAudienceSearch } from "modules/Campaigns/CampaignAssets/actions";
import { DYNAMIC_AUDIENCE_MATCHING } from "constants/actionTypes";
import { GLOBAL_ACTION } from "modules/GlobalActions";
import { useHistory } from "react-router-dom";
import { ISearchListContacts } from "../interface";
import { DebounceFunctionArgument } from "modules/Interface";

type Props = {
  setAToggle: (value: boolean) => void;
  aToggle?: boolean;
  onCancel?: any;
  handleOnClickBrowsePeople?: any;
  assetFlow?: boolean;
  peopleList?: any;
  contacts?: any;
  removeContact?: any;
  contactSidebarId?: number;
  fromSimilar?: boolean;
  inList?: boolean;
  selectAllFlag?: boolean;
  unselectedContactIdsState?: any[];
  selectedContactIdsFromBrowse?: any[];
  contactsFromBrowse?: any[];
  removedBrowseContactId?: number;
  setRemovedBrowseContactId?: (value: any) => void;
  deleteAllTotalCount?: number;
  selectAll?: boolean;
  selectAllList?: boolean;
  selectedCount?: number;
  deleteAllFlag?: boolean;
  contactsFromBrowseAddPeople?: any[];
  handleAddPeople?: any;
  setSelectedContactIdsFromBrowse?: any;
  setContactsFromBrowseAddPeople?: any;
  isOpen?: boolean;
  selectedOrganization?: string[];
  selectedDesignation?: string[];
  selectedPersonality?: string[];
  selectedStatus?: string[];
  idprefix?: string;
  fromGloabalListing?: boolean;
  globalList?: boolean;
  addPeopleMode?: boolean;
  createNewList?: boolean;
};

const NewListAsider: React.FC<Props> = ({
  setAToggle,
  aToggle,
  onCancel,
  assetFlow = false,
  contacts,
  contactSidebarId,
  fromSimilar,
  inList,
  selectAllFlag,
  unselectedContactIdsState = [],
  selectedContactIdsFromBrowse,
  contactsFromBrowse,
  removedBrowseContactId,
  setRemovedBrowseContactId,
  deleteAllTotalCount,
  selectAll,
  selectAllList,
  selectedCount,
  deleteAllFlag,
  contactsFromBrowseAddPeople,
  setSelectedContactIdsFromBrowse,
  setContactsFromBrowseAddPeople,
  isOpen,
  selectedOrganization,
  selectedDesignation,
  selectedPersonality,
  selectedStatus,
  idprefix,
  fromGloabalListing,
  globalList,
  addPeopleMode,
  createNewList,
}) => {
  // Local states
  const history = useHistory();
  const { Option } = Select;
  const { TextArea } = AntdInput;
  const pathname = window.location.pathname;
  const suggestedEmailDropdown: any[] = [];
  const [listNameToSave, setListNameToSave] = useState("");
  const [listName, setListName] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [disableButtonInList, setDisableButtonInList] = useState(false);
  const [showError, setShowError] = useState(false);
  const [fromSimilarState, setFromSimilar] = useState(fromSimilar ? fromSimilar : false);
  const [error, setError] = useState("");
  const [showNewListModule, setShowNewListModule] = useState(false);
  const [selectedList, setSelectedList] = useState("");
  const [openStateDropdown, setOpenStateDropdown] = useState(false);
  const [addPeopleSearchValue, setAddPeopleSearchValue] = useState("");
  const [selectedContacts, setSelectedContacts]: any[] = useState([]);
  const [selectedContactsInAddPeople, setSelectedContactsInAddPeople]: any[] = useState([]);
  const [listDataNamesState, setListDataNamesState]: any[] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [firstTimeLoad, setFirstTimeLoad] = useState(false);
  const [contactsFromBrowsePeople, setContactsFromBrowsePeople]: any[] = useState([]); // state for contacts from browse
  const [contactsFromDropdown, setContactsFromDropdown]: any[] = useState([]); // state for contacts from dropdown
  const [allContactsInAddMore, setAllContactsInAddMore]: any[] = useState([]); // state for all contacts in add more people field
  const [contactsFromList, setContactsFromList]: any[] = useState([]); // state for contacts imported from list in the asider
  const [allContacts, setAllContacts]: any[] = useState([]); // state for all contacts that have been selected
  const [dynamicAudienceKeywords, setDynamicAudienceKeywords]: any[] = useState([]); // state for dynamic audience keywords
  const [skipFirstMount, setSkipFirstMount] = useState(false);
  // const [contactsFromAudience, setContactsFromAudience] = useState([]); // state for contacts imported from audience in the asider


  // Redux states
  const addLoading: any = useSelector((state: RootState) => state.audienceLists.addList.loading);
  const addSuccess: any = useSelector((state: RootState) => state.audienceLists.addList.success);
  const listCreateError: any = useSelector((state: RootState) => state.audienceLists.addList.fail);
  const errorMessage: any = useSelector((state: RootState) => state.audienceLists.message);
  const listDataNamesLoading: any = useSelector((state: RootState) => state.audienceListsReducerV2.listsDataNamesLoading);
  const listDataNames: any = useSelector((state: RootState) => state.audienceListsReducerV2.listsDataNames);
  const suggestedEmails = useSelector((state: RootState) => state.suggestedEmails.suggestedContacts);
  const suggestedEmailsLoading = useSelector((state: RootState) => state.suggestedEmails.loading);
  const searchErrorMessage = useSelector((state: RootState) => state.suggestedEmails.message);
  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);
  const listLoading: any = useSelector((state: RootState) => state.audienceLists.loading);
  const listAlreadyExists = useSelector((state: RootState) => state.audienceLists.listAlreadyExists);
  const searchTerm = useSelector((state: RootState) => state.peopleAudience.searchTermPeople);
  const audienceListDetailSearchTerm = useSelector((state: RootState) => state.audienceListDetailsReducerV2.searchTerm);
  const globalContactsSearchTerm = useSelector((state: RootState) => state.globalContacts.searchTerm);
  const recommendedSearchTerm = useSelector((state: RootState) => state.recommendedPeople.searchTerm);
  const totalCount = useSelector((state: RootState) => state.peopleAudience.totalCount);
  const totalCountList = useSelector((state: RootState) => state.audienceListDetails.totalContacts);
  const searchTermListDetails = useSelector((state: RootState) => state.audienceListDetails.searchTermListDetails);
  const totalCountWithoutList = useSelector((state: RootState) => state.peopleAudience.totalCountWithoutList);

  // const selectedRecommendedContacts = useSelector((state: RootState) => state.recommendedPeople.selectedRecommendedContacts);
  const selectedRecommendedContactsIds = useSelector((state: RootState) => state.recommendedPeople.selectedRecommendedContactsIds);
  const isSelectAllRecommendedContacts = useSelector((state: RootState) => state.recommendedPeople.isSelectAllRecommendedContacts);

  const getSearchTerm = () => {
    // New Audience List Detail Page
    if (pathname.includes("/audiences/view")) {
      return audienceListDetailSearchTerm
    }
    // New Audience Contact Page
    else if (pathname.includes("/audiences/contacts")) {
      return globalContactsSearchTerm;
    }
    // Old Audience List Detail Page
    else if (pathname.includes("/audiences/lists/view")) {
      return searchTermListDetails;
    }
    // Old Audience Contacts Page
    return searchTerm;
  }

  // Component Logic
  useEffect(() => {
    // console.log("selectedRecommendedContactsIds", selectedRecommendedContactsIds);
    if (isOpen && selectedContactIdsFromBrowse && selectedContactIdsFromBrowse.length > 0) {
      const newObjKeysAddPeople = selectedContactIdsFromBrowse?.map((contact: any) => {
        return { label: contact?.name?.trim() ?? contact?.email ?? contact?.label?.trim(), value: contact?.id ?? contact?.value };
      });
      setAllContacts(newObjKeysAddPeople);
      setContactsFromList(newObjKeysAddPeople);
      const alreadySelectedContactsArray = newObjKeysAddPeople?.map((contact: any) => {
        return contact?.value;
      });

      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.ALREADY_SELECTED_CONTACTS,
        alreadySelectedContacts: alreadySelectedContactsArray,
      });
    }
    if (dynamicAudienceKeywords.length > 0 || recommendedSearchTerm.length > 0) {
      setDynamicAudienceKeywords([]);
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS_RESET,
      });
    }
    store.dispatch({
      type: GLOBAL_ACTION.NEW_LIST_ASIDER_OPEN_STATE,
      payload: isOpen,
    });
    handleOnClear();
  }, [isOpen]);

  useEffect(() => {
    return () => {
      if (fromSimilar) {
        store.dispatch({
          type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS_RESET,
        });
      }
    };
  }, []);

  useEffect(() => {
    if (selectedContactIdsFromBrowse) {
      if (isSelectAllRecommendedContacts) {
        let ids = contactsFromBrowsePeople?.map((contact: any) => contact?.id);
        let allContactsWithoutBrowse = allContacts?.filter((contact: any) => !ids?.includes(contact?.id));
        let allContactsInAddMoreWithoutBrowse = allContactsInAddMore?.filter((contact: any) => !ids?.includes(contact?.id));
        let contactsFromBrowsePeopleNew = selectedContactIdsFromBrowse?.map((contact: any) => ({
          label: contact?.name?.trim() ?? contact?.label?.trim() ?? contact?.email,
          value: contact?.id ?? contact?.value
        }));
        allContactsWithoutBrowse = allContactsWithoutBrowse.concat(contactsFromBrowsePeopleNew);
        allContactsInAddMoreWithoutBrowse = allContactsInAddMoreWithoutBrowse.concat(contactsFromBrowsePeopleNew);
        setAllContacts(allContactsWithoutBrowse);
        setAllContactsInAddMore(allContactsInAddMoreWithoutBrowse);
        setContactsFromBrowsePeople(contactsFromBrowsePeopleNew);
      } else {
        if (contactsFromBrowsePeople.length > selectedContactIdsFromBrowse.length) {
          // handle remove case
          let ids = selectedContactIdsFromBrowse?.map((contact: any) => contact?.id);
          let contactToRemove = contactsFromBrowsePeople?.filter((contact: any) => !ids?.includes(contact?.value));
          if (contactToRemove.length > 0) {
            let removeIds = contactToRemove.map((contact: any) => contact?.value);
            let allContactsNew = allContacts.filter((contact: any) => !removeIds.includes(contact.value));
            let allContactsInAddMoreNew = allContactsInAddMore.filter((contact: any) => !removeIds.includes(contact.value));
            let contactsFromBrowsePeopleNew = contactsFromBrowsePeople.filter((contact: any) => !removeIds.includes(contact.value));
            setAllContacts(allContactsNew);
            setAllContactsInAddMore(allContactsInAddMoreNew);
            setContactsFromBrowsePeople(contactsFromBrowsePeopleNew);
          }
        } else {
          let newObjKeysAddPeople = selectedContactIdsFromBrowse?.map((contact: any) => ({
            label: contact?.name ?? contact?.label,
            value: contact?.id ?? contact?.value
          }));
          setContactsFromBrowsePeople(newObjKeysAddPeople);
          const objToAdd = [...newObjKeysAddPeople]?.pop();
          let objAlreadyExists = false;
          allContactsInAddMore?.map((listItem: any) => {
            if (listItem?.value === objToAdd?.value) {
              objAlreadyExists = true;
            }
          });
          if (!objAlreadyExists && objToAdd) {
            setAllContacts([...allContacts, objToAdd]);
            setAllContactsInAddMore([...allContactsInAddMore, objToAdd]);
          }
        }
      }
    }
  }, [selectedContactIdsFromBrowse]);

  useEffect(() => {
    if (contactsFromDropdown.length > 0) {
      const objToAdd = contactsFromDropdown?.pop();
      setAllContacts([...allContacts, objToAdd]);
      setAllContactsInAddMore([...allContactsInAddMore, objToAdd]);
    }
  }, [contactsFromDropdown]);

  useEffect(() => {
    setShowError(false);
  }, [listCreateError && showError]);

  useEffect(() => {
    if (listDataNames.length > 0) {
      const filteredListDataNames = listDataNames.filter((list: any) => list.listId !== getQueryListId());
      setListDataNamesState(filteredListDataNames);
    }
  }, [listDataNames]);

  useEffect(() => {
    if (addLoading) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [addLoading]);

  useEffect(() => {
    if (addSuccess) {
      setDisableButton(true);
      setListNameToSave("");
      setDescriptionValue("");
      onCancel();
    }
  }, [addSuccess]);

  function handleCreateNewList() {
    createNewAudienceList(
      cancelHandle,
      setDisableButtonInList,
      setAToggle,
      history,
      listNameToSave?.trim(),
      allContacts.map((contact: any) => contact.value),
      fromSimilarState,
      contactSidebarId
    );
    setDisableButton(true);
  }

  function handleCreateNewListInList() {
    createNewAudienceList(
      cancelHandle,
      setDisableButtonInList,
      setAToggle,
      history,
      showNewListModule ? listName?.trim() : listNameToSave,
      allContacts.map((contact: any) => contact.value),
      fromSimilarState,
      contactSidebarId,
      !showNewListModule ? selectedList : "",
      selectAllFlag,
      unselectedContactIdsState,
      inList,
      pathname.includes("/view") ? getQueryListId().toString() : undefined,
      !inList ? true : false,
      selectedOrganization,
      selectedDesignation,
      selectedPersonality,
      selectedStatus,
      getSearchTerm(),
      false,
      false,
      fromGloabalListing,
    );
    setDisableButtonInList(true);
  }
  useEffect(() => {
    if (!listLoading && disableButtonInList) {
      setDisableButtonInList(false);
    }
  }, [listLoading]);

  useEffect(() => {
    if (firstTimeLoad) {
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
      }, 3000);
    } else {
      setFirstTimeLoad(true);
    }
  }, [listAlreadyExists]);

  const cancelHandle = () => {
    setListNameToSave("");
    setDescriptionValue("");
    store.dispatch({ type: AUDIENCE_LISTS_ADD.RESET });
    setShowError(false);
    setShowNewListModule(false);
    setSelectedList("");
    onCancel();
  };
  // creating this function to close new list module if it is open when click on dropdown
  const cancelHandleNewModule = () => {
    setListNameToSave("");
    setDescriptionValue("");
    store.dispatch({ type: AUDIENCE_LISTS_ADD.RESET });
    setShowError(false);
    setShowNewListModule(false);
    setSelectedList("");
  };

  const handleInputChange = (e: any) => {
    let value = e.target.value;
    if (value.trim().length === 0) {
      setDisableButton(true);
      setDisableButtonInList(true);
    } else {
      setDisableButton(false);
      setDisableButtonInList(false);
    }
    // handling ',' in list name to avoid any issue in publish emails fileds
    if (value.includes(",")) {
      setError("',' is not allowed in list names.");
    } else {
      setListNameToSave(value?.replace(",", ""));
      if (error) setError("");
    }
  };

  const handleInputChangeNewList = (e: any) => {
    let value = e.target.value;
    if (value.trim().length === 0) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
    // handling ',' in list name to avoid any issue in publish emails fileds
    if (value.includes(",")) {
      setError("',' is not allowed in list names.");
    } else {
      // const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      // if (!specialChars.test(value)) 
      setListName(value);
      if (error) setError("");
      if (pathname.startsWith("/audiences/lists") && disableButtonInList)
        setDisableButtonInList(false);
    }
    if (disableButtonInList) {
      setDisableButtonInList(false);
    }
  };

  const onClickCreateList = (e: any) => {
    setShowNewListModule(true);
    setListName("");
  };

  const handleSelectedList = (e: any) => {
    setSelectedList(e);
    setShowNewListModule(false);
  };

  useEffect(() => {
    if (showNewListModule === true) {
      setSelectedList("");
    }
  }, [showNewListModule]);

  useEffect(() => {
    if (contacts?.length > 0 && isOverlay) {
      const newObjKeys = contacts?.map((contact: any) => {
        return { label: contact?.contactName ?? contact.name, value: contact?.contactId ?? contact?.id };
      });
      const filteredObj = newObjKeys.filter((item: any) => item.value !== undefined);
      setContactsFromList(filteredObj);
      setAllContacts(filteredObj);
      // const alreadySelectedContactsArray = filteredObj?.map((contact: any) => {
      //   return contact?.id;
      // });

      // store.dispatch({
      //   type: DYNAMIC_AUDIENCE_MATCHING.ALREADY_SELECTED_CONTACTS,
      //   alreadySelectedContacts: alreadySelectedContactsArray,
      // });
    }
  }, [contacts, isOverlay]);

  useEffect(() => {
    if (selectedContactIdsFromBrowse && selectedContactIdsFromBrowse.length > 0) {
      const newObjKeys = selectedContactIdsFromBrowse.map((contact: any) => {
        return { label: contact?.name ?? contact?.label, value: contact?.id ?? contact?.value };
      });
      const filteredObj = newObjKeys.filter((item) => item.value !== undefined);
      setSelectedContacts(filteredObj);
      const newObjKeysAddPeople = contactsFromBrowseAddPeople?.map((contact: any) => {
        return { label: contact?.name ?? contact?.label, value: contact?.id ?? contact?.value };
      });
      const filteredObjAddPeople = newObjKeysAddPeople?.filter((item) => item.value !== undefined);
      setSelectedContactsInAddPeople(filteredObjAddPeople);
    } else {
      if (removedBrowseContactId !== 0) {
        const obj = selectedContacts.filter((contact: any) => contact.value !== removedBrowseContactId);
        setSelectedContacts(obj);
        const objAddPeople = selectedContactsInAddPeople.filter(
          (contact: any) => contact.value !== removedBrowseContactId
        );
        setSelectedContactsInAddPeople(objAddPeople);
        setRemovedBrowseContactId && setRemovedBrowseContactId(0);
      } else {
        if (contactsFromBrowse && contactsFromBrowse.length > 0) {
          const obj = contactsFromBrowse?.pop();
          setSelectedContacts([
            ...selectedContacts,
            { label: obj?.name ?? obj?.label, value: obj?.id ?? obj?.value },
          ]);
          setSelectedContactsInAddPeople([...selectedContactsInAddPeople, { label: obj?.name, value: obj?.id }]);
        }
        if (contactsFromBrowseAddPeople && contactsFromBrowseAddPeople.length > 0) {
          const objAddPeople = contactsFromBrowseAddPeople?.pop();
          setSelectedContactsInAddPeople([
            ...selectedContactsInAddPeople,
            { label: objAddPeople?.name ?? objAddPeople?.label, value: objAddPeople?.id ?? objAddPeople?.value },
          ]);
        }
      }
    }
  }, [selectedContactIdsFromBrowse]);

  function handleKeyDown(e: any) {
    setOpenStateDropdown(true);
  }

  const onSearchHandler = (value: any) => {
    setAddPeopleSearchValue(value);
  };

  const handleOnClear = () => {
    setAddPeopleSearchValue("");
    setOpenStateDropdown(false);
    setSelectedContacts([]);
    setSelectedContactsInAddPeople([]);
    setSelectedContactIdsFromBrowse([]);
    setContactsFromBrowseAddPeople([]);
    setContactsFromBrowsePeople([]);
    setContactsFromDropdown([]);
    setAllContactsInAddMore([]);
    setAllContacts(contactsFromList);
  };

  suggestedEmails.map((contact: any, index) => {
    suggestedEmailDropdown.push(
      <Option key={index} value={contact?.contact_id}>
        {contact.contact_name.trim() !== "" ? contact.contact_name.replaceAll(",", " ") : contact.contact_email}
      </Option>
    );
  });

  function tagRender(props: any) {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: any) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        style={{
          marginRight: 3,
          borderRadius: 15,
          backgroundColor: "#E7EDFF",
          color: "#001760",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          padding: "3px 5px",
          margin: "2px 1px",
        }}
      >
        {label}
        <span
          onClick={() => {
            removeFromSelectedContactsHandler({ value, label });
          }}
          className="icon-cross clear-item"
        >
          <CrossIcon />
        </span>
      </Tag>
    );
  }

  const selectContactsFromDropdownHandler = (obj: any) => {
    const newObj = { label: obj.label, value: obj.value };
    setSelectedContacts([...selectedContacts, newObj]);
    setSelectedContactsInAddPeople([...selectedContactsInAddPeople, newObj]);
    setContactsFromDropdown([...contactsFromDropdown, newObj]);
    setAddPeopleSearchValue("");
    setOpenStateDropdown(false);
    selectedContactIdsFromBrowse && setSelectedContactIdsFromBrowse([...selectedContactIdsFromBrowse, newObj]);
  };

  const removeFromSelectedContactsHandler = (obj: any) => {
    let removeFromAllContacts = true;
    contactsFromList?.map((listItem: any) => {
      if (listItem.value === obj.value) {
        removeFromAllContacts = false;
      }
    });
    if (removeFromAllContacts) {
      const filteredArrAllContacts = allContacts?.filter(
        (allContactsItem: any) => allContactsItem.value !== obj.value
      );
      setAllContacts(filteredArrAllContacts);
    }
    const filteredArrContactsInAddMore = allContactsInAddMore?.filter((item: any) => item.value !== obj.value);
    const filteredArrContactsFromBrowsePeople = contactsFromBrowsePeople?.filter(
      (item: any) => item.value !== obj.value
    );
    const filteredArrContactsFromDropdown = contactsFromDropdown?.filter((item: any) => item.value !== obj.value);
    setAllContactsInAddMore(filteredArrContactsInAddMore);
    setContactsFromBrowsePeople(filteredArrContactsFromBrowsePeople);
    setContactsFromDropdown(filteredArrContactsFromDropdown);
    setSelectedContactIdsFromBrowse(filteredArrContactsInAddMore);
  };

  const delayedSearchListContacts = useCallback(
    debounce((...args: DebounceFunctionArgument) => {
      searchListContacts(args[0] as string, args[1] as ISearchListContacts)
    }),
    []
  );

  useEffect(() => {
    if (addPeopleSearchValue.length > 0) {
      const alreadySelectedContactsIdsArray = contactsFromList?.map((contact: any) => {
        return contact?.value;
      });
      const params: ISearchListContacts = {
        selectAllFlag: selectAllFlag ? selectAllFlag : false,
        alreadySelectedContactsIds: alreadySelectedContactsIdsArray,
        listId: getQueryListId() > 0 ? getQueryListId().toString() : "",
        excludedIds: unselectedContactIdsState.length > 0 ? unselectedContactIdsState : [],
      };
      delayedSearchListContacts(addPeopleSearchValue, params);
      suggestedEmails.map((contact: any, index: number) => {
        suggestedEmailDropdown.push(
          <Option key={index} value={contact?.contact_id}>
            {contact.contact_name.trim() !== ""
              ? contact.contact_name.replaceAll(",", " ")
              : contact.contact_email}
          </Option>
        );
      });
    }
  }, [addPeopleSearchValue]);

  const addDynamicAudienceKeyword = (keyword: string) => {
    if (keyword.trim() !== "") {
      if (keyword.includes(",")) {
        const keywordArr = keyword.split(",").filter((item: string) => {
          if (item.trim() !== "") return item.toLowerCase().trim().replace(" and ", " AND ");
        });
        if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0) {
          const newKeywordArr = dynamicAudienceKeywords;
          keywordArr.map((item: string) => {
            if (!dynamicAudienceKeywords.includes(item)) {
              newKeywordArr.push(item);
            }
          });
          setDynamicAudienceKeywords([...new Set(newKeywordArr)]);
        } else {
          let uniqueKeywrodsArray = [...new Set(keywordArr)];
          setDynamicAudienceKeywords(uniqueKeywrodsArray);
        }
      } else {
        if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0) {
          if (!dynamicAudienceKeywords.includes(keyword.toLowerCase().trim())) {
            setDynamicAudienceKeywords([
              ...dynamicAudienceKeywords,
              keyword.toLowerCase().trim().replace(" and ", " AND "),
            ]);
          }
        } else {
          setDynamicAudienceKeywords([keyword.toLowerCase().trim().replace(" and ", " AND ")]);
        }
      }
    }
  };

  const removeDynamicAudienceKeyword = (keyword: string) => {
    const newKeywords = dynamicAudienceKeywords?.filter((item: string) => item !== keyword);
    setDynamicAudienceKeywords(newKeywords);
  };

  useEffect(() => {
    if (skipFirstMount) {
      if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0) {
        dynamicAudienceSearch(
          0,
          50,
          recommendedSearchTerm,
          dynamicAudienceKeywords.join(","),
          selectAllFlag,
          getQueryListId().toString(),
          unselectedContactIdsState
        );
        store.dispatch({
          type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
          dynamicKeywords: dynamicAudienceKeywords,
        });
      } else {
        dynamicAudienceSearch(
          0,
          50,
          recommendedSearchTerm,
          "",
          selectAllFlag,
          getQueryListId().toString(),
          unselectedContactIdsState
        );
        store.dispatch({
          type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
          dynamicKeywords: [],
        });
      }
    } else {
      setSkipFirstMount(true);
    }
  }, [dynamicAudienceKeywords]);

  // const loadDynamicAudience = (reset?: boolean) => {
  //   if (dynamicAudienceKeywords && dynamicAudienceKeywords.length > 0) {
  //     dynamicAudienceSearch(
  //       reset ? 0 : ,
  //       50,
  //       recommendedSearchTerm,
  //       dynamicAudienceKeywords.join(","),
  //       selectAllFlag,
  //       getQueryListId().toString(),
  //       unselectedContactIdsState
  //     );
  //     store.dispatch({
  //       type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
  //       dynamicKeywords: dynamicAudienceKeywords,
  //     });
  //   } else {
  //     dynamicAudienceSearch(
  //       0,
  //       50,
  //       recommendedSearchTerm,
  //       "",
  //       selectAllFlag,
  //       getQueryListId().toString(),
  //       unselectedContactIdsState
  //     );
  //     store.dispatch({
  //       type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
  //       dynamicKeywords: [],
  //     });
  //   }
  // }

  return (
    <Wrapper
      className={`wrapper-campaign-keyword  ${aToggle ? "open" : ""}`}
      style={{ width: "100%", borderLeft: assetFlow ? "2px solid #e4e4e4" : "0" }}
      fromSimilar={fromSimilar}
      inList={inList}
    >
      <div className="create-campaign-wrapper-two">
        {!createNewList && (inList || !fromSimilar) ? (
          <h1 className="create-campaign-heading">
            Add to
            <br />
            List
          </h1>
        ) : (
          <h1 className="create-campaign-heading">
            Create New
            <br />
            List
          </h1>
        )}
      </div>
      <div className="d-flex flex-column scrollable">
        <div className="popover-body">
          <div className="d-flex flex-column">
            {listCreateError && (
              <div className="mt-2">
                <FadeIn>
                  <Message type="error" label="Error" message={errorMessage} />
                </FadeIn>
              </div>
            )}
            {(!inList || fromSimilar) && (
              <div className="mt-3" hidden={!showErrorMessage}>
                <Message type="error" message="List with that name already exists" />
              </div>
            )}
            <div hidden={!createNewList && (inList || !fromSimilar)} className="list-name-field">
              <h3 className="add-word-head">{"Name your new list"}</h3>
            </div>
            <div hidden={!createNewList && (inList || !fromSimilar)} className={`edit-wrapper-two margin-align `}>
              {/* Toggle editable-active class */}
              <span className="name-two" data-id="qa-name-list">
                <Input
                  type="text"
                  placeholder="New list name here"
                  value={listNameToSave}
                  onChange={handleInputChange}
                  error={error}
                  errorDown={true}
                  maxLength={100}
                  inNewListAsider={true}
                  idInput={"new_list_name_" + idprefix}
                />
              </span>
            </div>

            {!createNewList && (pathname.startsWith("/audiences") ||
              pathname.startsWith("/campaigns/content/audience")) ? (
              <div className={`d-flex align-items-center selected-people-count`}>
                <div className="multi-select">
                  <Checkbox checked={true} readOnly />
                  <Checkbox checked={true} readOnly />
                </div>
                {fromSimilar ? (
                  <span className="count" style={{ display: "inline-flex" }}>
                    {contacts?.length} {contacts?.length === 1 ? "contact" : "contacts"} selected
                  </span>
                ) : (
                  <span className="count" style={{ display: "inline-flex" }}>
                    {deleteAllFlag && !selectAll ?
                      (addPeopleMode && deleteAllTotalCount && globalList && unselectedContactIdsState) ?
                        totalCountWithoutList - unselectedContactIdsState?.length
                        : deleteAllTotalCount
                      : selectedCount}{" "}
                    {contacts?.length === 1 ? "contact" : "contacts"} selected
                  </span>
                )}
              </div>
            ) : null}

            <Row className={`${fromSimilar ? "dynamic-audience-style from-similar" : "dynamic-audience-style"}`}>
              <Col>
                <h2 className="add-word-head large">{"Dynamic audience matching"}</h2>
                <KeywordSourceV2
                  heading="Keywords to find matching contacts"
                  placeholder="Start typing Keywords to find the best matching contacts…"
                  desc="Our Smart Content Engine finds the best matching contacts for your lists based on the added keywords."
                  marginTop="20px"
                  marginBottom="20px"
                  searchTerms={dynamicAudienceKeywords}
                  handleAddSearchTerm={addDynamicAudienceKeyword}
                  handleOnRemove={removeDynamicAudienceKeyword}
                  inNewListAsider={true}
                  idprefix={idprefix}
                ></KeywordSourceV2>
              </Col>
              <Col span={18}>
                <div className="wrapper">
                  <h3 className="add-word-head">{"Add contacts"}</h3>
                </div>
              </Col>
            </Row>
            {inList ? (
              <div className="margined-input input-with-upload" data-id="qa-list-container">
                <Select
                  mode="multiple"
                  open={openStateDropdown}
                  notFoundContent={null}
                  data-id="qa-dropdown-list"
                  onBlur={(e: any) => {
                    setOpenStateDropdown(false);
                    setAddPeopleSearchValue("");
                  }}
                  onKeyDown={(e: any) => {
                    handleKeyDown(e);
                  }}
                  filterOption={false}
                  onSearch={onSearchHandler}
                  searchValue={addPeopleSearchValue}
                  allowClear
                  onClear={handleOnClear}
                  style={{ width: "100%" }}
                  placeholder="Type name or email address"
                  tagRender={tagRender}
                  labelInValue={true}
                  value={allContactsInAddMore}
                  onSelect={(e: any) => selectContactsFromDropdownHandler(e)}
                >
                  {suggestedEmailsLoading ? (
                    <>
                      <Option disabled={true} value={"Fetching"}>
                        Fetching...
                      </Option>
                    </>
                  ) : suggestedEmailDropdown.length > 0 ? (
                    suggestedEmailDropdown
                  ) : searchErrorMessage ? (
                    <>
                      <Option disabled={true} value={"No Data"}>
                        No Match Found!
                      </Option>
                    </>
                  ) : (
                    <>
                      <Option disabled={true} value={"No Data"}>
                        No Match Found!
                      </Option>
                    </>
                  )}
                </Select>
              </div>
            ) : (
              <div className="margined-input input-with-upload" data-id={"qa-search-selectors-" + idprefix}>
                <Select
                  mode="multiple"
                  open={openStateDropdown}
                  notFoundContent={null}
                  data-id="qa-dropdown-list"
                  onBlur={(e: any) => {
                    setOpenStateDropdown(false);
                    setAddPeopleSearchValue("");
                  }}
                  onKeyDown={(e: any) => {
                    handleKeyDown(e);
                  }}
                  filterOption={false}
                  onSearch={onSearchHandler}
                  searchValue={addPeopleSearchValue}
                  allowClear
                  onClear={handleOnClear}
                  style={{ width: "100%" }}
                  placeholder="Type name or email address"
                  tagRender={tagRender}
                  labelInValue={true}
                  value={allContactsInAddMore}
                  // value={[{ value: 12, label: 'afzal' }]}
                  onSelect={(e: any) => selectContactsFromDropdownHandler(e)}
                >
                  {suggestedEmailsLoading ? (
                    <>
                      <Option disabled={true} value={"Fetching"}>
                        Fetching...
                      </Option>
                    </>
                  ) : suggestedEmailDropdown.length > 0 ? (
                    suggestedEmailDropdown
                  ) : (
                    <>
                      <Option disabled={true} value={"No Data"}>
                        No Match Found!
                      </Option>
                    </>
                  )}
                </Select>
              </div>
            )}
          </div>
          <br />
          <div>
            {!createNewList && (inList || !fromSimilar) ? (
              <>
                <Wrap>
                  <h5 className="heading-dropdown mb-1">Add to list</h5>
                  <CustomSelectAsset
                    campaigns_list={[]}
                    listDataNamesLoading={listDataNamesLoading}
                    listDataNames={listDataNames}
                    inList={true}
                    listsData={listDataNamesState}
                    campaignName={"Please select..."}
                    selectedValue={
                      showNewListModule
                        ? "Create new list"
                        : listDataNames?.find(
                          (item: any) => selectedList?.toString() === item?.listId?.toString()
                        )?.listName
                    }
                    setCampaignName={(value: string) => {
                      setListName(value);
                    }}
                    setSelectedCampaign={handleSelectedList}
                    onClickCreateCampaign={(value: any) => {
                      onClickCreateList(value);
                    }}
                    showNewListModule={showNewListModule}
                    cancelHandle={cancelHandleNewModule}
                  />
                </Wrap>
                <div className="mt-3" hidden={!showErrorMessage}>
                  <Message type="error" message="List with that name already exists" />
                </div>
                {showNewListModule ? (
                  <div className={showNewListModule ? "new-campaign-bottom" : "d-none"}>
                    <NewListModule listName={listName} setListName={handleInputChangeNewList} />
                  </div>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <div className="wrapper">
                  <h3 className="add-word-head">{"Add description"}</h3>
                  {<span className="sub-text">(optional)</span>}
                </div>
                <div className="margined-input">
                  <TextArea
                    autoSize={{ minRows: 4, maxRows: 6 }}
                    placeholder="Start typing your description..."
                    rows={4}
                    onChange={(e: any) => {
                      setDescriptionValue(e.target.value);
                    }}
                    value={descriptionValue}
                    className="round-field"
                    id={"description-" + idprefix}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <FooterActionButton>
          <span className={`footer-btn mr`} onClick={cancelHandle}>
            Cancel
          </span>
          {!createNewList || inList ? (
            <span
              className={`footer-btn filled-success ${disableButtonInList ||
                (showNewListModule && listName.trim() === "") ||
                (!showNewListModule &&
                  (selectedList.trim() === "" ||
                    (selectedCount && selectedCount <= 0 && selectedContacts?.length === 0)) && listNameToSave.trim() === "")
                ? "opaque-button"
                : ""
                }`}
              data-id="qa-save-btn-one"
              onClick={handleCreateNewListInList}
            >
              Save
            </span>
          ) : (
            <span
              className={`footer-btn filled-success ${disableButton || listNameToSave.length === 0 ? "opaque-button" : ""
                }`}
              data-id="qa-save-btn"
              onClick={handleCreateNewList}
            >
              Save
            </span>
          )}
        </FooterActionButton>
        {/* </div> */}
      </div>
    </Wrapper>
  );
};

export default NewListAsider;

const Wrap = styled.div`
  .heading-dropdown {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    color: #5e7079;
    font-size: 20px;
    margin-top: 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      /* margin-top: 30px; */
      font-size: 12px;
    }
  }
`;

const Wrapper = styled.div<{ fromSimilar?: boolean; inList?: boolean }>`
  transition: ease all 0.1s;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  width: 0px;
  background-color: #fff;
  position: relative;
  .list-name-field {
    margin-top: 25px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 10px;
    }
  }
  .dynamic-audience-style {
    margin-top: 40px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 30px;
    }
    &.from-similar {
      margin-top: 25px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 15px;
      }
    }
  }
  .selected-people-count {
    margin-top: 20px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 10px;
    }
  }
  .multi-select {
    position: relative;
    width: 35px;
    height: 45px;
    > div {
      position: absolute;
      top: 10px;
      left: 0;
      z-index: 9;
      span {
        background-color: #fff;
      }
      + div {
        top: 15px;
        left: 5px;
        z-index: 8;
      }
    }
  }
  &.open {
    width: 530px !important;
  }
  .count {
    color: #7e7e7e;
    font-family: "Roboto Slab", serif;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
  }
  .clear-item {
    cursor: pointer;
    svg {
      width: 15px;
      height: 16px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 12px;
        height: auto;
      }
      circle {
        fill: #001760;
        fill-opacity: 1;
        opacity: 1;
      }
    }
  }
  .input-with-upload {
    .ant-tag {
      white-space: nowrap;
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      justify-content: start;
      display: block !important;
      padding-right: 25px !important;
      position: relative;
      .icon-cross {
        position: absolute;
        right: 5px;
        top: 2px;
      }
    }
  }
  .new-campaign-bottom {
    margin-bottom: 20px;
  }
  .scrollable {
    max-height: ${(props) => (props.inList ? "calc(100vh - 225px)" : "calc(100vh - 250px)")};
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: ${(props) => (props.inList ? "calc(100vh - 200px)" : "calc(100vh - 220px)")};
    }
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 2px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      background: #efefef;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  &.open {
    width: 100% !important;
    transition: ease all 0.1s;
    overflow: hidden;
    @media all and (max-height: 1439px) and (min-height: 600px) {
      justify-content: space-between;
      align-items: center;
      .btn-wrapper {
        display: flex;
        align-items: center;
        .ml {
          margin-left: 12px;
        }
      }
    }
    .asset-name-two {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      max-width: 700px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 445px;
      }
    }
    .margined-input {
      margin-top: 8px;
      label {
        margin: 0px;
      }
      &.input-with-upload {
        .ant-select:not(.ant-select-customize-input) .ant-select-selector {
          height: auto;
          min-height: 48px;
          max-height: 132px;
          border-radius: 10px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            min-height: 38px;
            border-radius: 6px;
          }
          overflow: auto;
          scrollbar-width: thin;
          scrollbar-color: #001760 #efefef;
          ::-webkit-scrollbar {
            width: 5px;
            height: 5px;
            border-radius: 2px;
          }
          /* Track */
          ::-webkit-scrollbar-track {
            background: #efefef;
            margin-top: 10px;
            margin-bottom: 15px;
          }
          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #001760;
          }
          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .ant-select-selection-placeholder {
            font-family: "robotothin_italic";
            color: #c1c1c1;
            font-weight: 600;
            font-size: 14px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 12px;
            }
          }
          .ant-select-selection-overflow {
            padding-left: 10px;
          }
        }
      }
    }
    .text-style {
      font-size: 14px;
      font-weight: 600;
      color: #5e7079;
    }
    .name-two {
      color: rgb(155, 155, 155);
      position: relative;
      float: left;
      display: flex;
      align-items: center;
      width: 100%;
      div {
        width: 100%;
      }
      .tooltip {
        position: relative;
        display: inline-block;
        opacity: 1;
        z-index: 0;
        .tooltiptext {
          color: #ffffff;
          font-size: 11px;
          letter-spacing: 0.02px;
          line-height: 15px;
          text-align: center;
          background-color: #263153;
          visibility: hidden;
          border-radius: 4px;
          padding: 5px 0;
          position: absolute;
          z-index: 1;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          padding: 5px 10px;
          &:after {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #263153 transparent transparent transparent;
          }
        }
        &:hover .tooltiptext {
          visibility: visible;
          opacity: 1;
        }
      }
      .asset-name-two {
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        white-space: nowrap;
        float: left;
        max-width: 700px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          max-width: 445px;
        }
      }
      &.editable-active {
        .editable {
          display: block;
          min-width: 320px;
        }
      }
      .editable {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        display: none;
        label {
          display: none;
        }
        input {
          padding-right: 70px;
        }
        .save {
          position: absolute;
          top: 9px;
          right: 10px;
          height: 100%;
          cursor: pointer;
          img {
            vertical-align: middle;
            max-width: 20px;
          }
        }
        .cancel {
          position: absolute;
          top: 9px;
          right: 40px;
          height: 100%;
          cursor: pointer;
          img {
            vertical-align: middle;
            max-width: 20px;
            padding: 2px;
          }
        }
      }
      .edit-btn {
        cursor: pointer;
        margin-left: 10px;
      }
    }
    .scroll-Wrapper-two {
      height: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      // @media all and (max-height: 780px) {
      max-height: calc(100vh - 280px);
      // }
      .search-terms-wrap {
        .wrapper-content {
          flex-direction: row;
          align-items: baseline;
        }
      }

      scrollbar-width: thin;
      scrollbar-color: #001760 #efefef;
      &::-webkit-scrollbar {
        display: none;
      }
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
    .create-campaign-wrapper-two {
      padding: 0px 40px;
      position: relative;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 0px 20px;
      }
      .create-campaign-heading {
        color: #424b50;
        font-size: 46px;
        font-weight: 500;
        line-height: 48px;
        margin-bottom: 0px;
        margin-top: 13px;
        display: block;
        font-family: "Roboto Slab", serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 32px;
          line-height: 34px;
        }
      }
      .edit-wrapper-two {
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 10px;
          margin-bottom: 10px;
        }
        &.margin-align {
          margin: 8px 0px 0px 0px;
        }
        .new-campaign {
          color: #9b9b9b;
          font-size: 22px;
          line-height: 47px;
          margin-bottom: 0px;
          display: inline-block;
          font-family: "Roboto Slab", serif;
        }
        .edit-icon {
          margin-left: 10px;
          cursor: pointer;
        }
        &.editable-active {
          .editable {
            display: block;
            min-width: 320px;
          }
        }
      }
    }
  }
  .green-button {
    font-weight: bold;
    font-size: 12px;
    color: #27ce0a;
    border: 1px solid #27ce0a;
    padding: 2px 8px;
    border-radius: 6px;
    cursor: pointer;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    &.green-bg {
      background-color: #1ec252;
      color: #ffffff;
      border: 1px solid #1ec252;
    }
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 4px;
      font-size: 9px;
    }
  }
  .add-word-head {
    color: #5e7079;
    font-size: 20px;
    margin-bottom: 0px;
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    display: inline-block;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
    &.large {
      font-family: "Roboto Slab";
      font-size: 28px;
      color: #424b50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 20px;
      }
    }
  }
  .sub-text {
    font-size: 14px;
    margin-left: 3px;
    font-weight: 600;
    opacity: 0.4;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 10px;
    }
  }
  .margined-import-button {
    margin-top: 40px;
    margin-bottom: 54px;
  }

  .popover-body {
    padding: 1rem 40px;
    margin-bottom: 50px;
    height: 100vh !important;
    max-width: calc(100% - 5px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 1rem 20px;
    }
  }
  .footer {
    margin-top: 125px;
  }
  .round-field {
    border-radius: 8px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      border-radius: 6px;
    }
    &::placeholder {
      font-family: "robotothin_italic";
      color: #c1c1c1;
      font-weight: 600;
      font-size: 14px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .opaque-button {
    opacity: 0.3;
    cursor: default !important;
    pointer-events: none;
  }
`;
